<template>
  <aside ref="sidebarElem" class="sidebar" :class="[`sidebar--${position}`, {'sidebar--show': isOpen}]"  id="sidebar" aria-labelledby="filter-button" v-show="!hidden">
    <div class="sidebar__inner">
      <div class="sidebar__top">
        <button class="button button--close" title="Lukk" v-on:click.prevent="close"></button>
      </div>
      <div class="sidebar__filters">
        <slot></slot>
      </div>
    </div>
  </aside>
</template>

<script type="ts">
import { Vue, Component, Prop, Ref } from 'vue-property-decorator'

@Component
export default class Sidebar extends Vue {
  @Prop({default: 'left', type: String}) position: string;
  @Ref() readonly sidebarElem: HTMLElement;

  public isOpen: boolean = false;
  public hidden: boolean = true;

  public handleDocumentClick(e: MouseEvent) {
    if (!this.isOpen) {
      return;
    }

    if (!this.sidebarElem.contains(e.target as HTMLElement)) {
      this.close();
    }
  }

  public open() {
    this.isOpen = true;
    this.hidden = false;

    this.$nextTick(() => {
      document.addEventListener('click', this.handleDocumentClick, {
        capture: true
      });
    });
  }

  public close() {
    this.isOpen = false;

    document.removeEventListener('click', this.handleDocumentClick, {
      capture: true
    });

    setTimeout(() => {
      this.hidden = true;
    }, 200);
  }

  public toggle() {
    this.isOpen = !this.isOpen;
  }
}
</script>